// src/config/ticket.matrix.ts
import {
  MenuId, CategoryId, FunctionId, TeamId, RoleId, LabeledOption,
} from './ticket';

export const MENU_OPTS: LabeledOption<MenuId>[] = [
  { id: 'Input View',      label: 'Input View' },
  { id: 'Output View', label: 'Output View' },
  { id: 'SSA Dashboard',           label: 'SSA Dashboard' },
  { id: 'Approver Maintenance', label: 'Approver Maintenance' },
  { id: 'Data Error', label: 'Data Error' },
  {id: 'Approver', label: 'Approver'},
  { id: 'SSA Control', label: 'SSA Control' },
];
export const MENU_BY_ROLE: Record<RoleId, MenuId[]> = {
  planner: ['Input View', 'Output View'],
  admin:   ['SSA Dashboard', 'Approver Maintenance', 'Data Error', 'SSA Control'],
  approver :['Approver']
};

export const CATEGORY_OPTS: LabeledOption<CategoryId>[] = [
  { id: 'inbound',  label: 'Data' },
  { id: 'Functionality', label: 'Functionality' },
];
export const CATEGORY_OPTS_ADMIN: LabeledOption<CategoryId>[] = [
  { id: 'inbound',  label: 'Data' },
  { id: 'outbound', label: 'Outbound' },
  { id: 'Functionality', label: 'Functionality' },
];
export const FUNCTION_ALL: LabeledOption<FunctionId>[] = [
  { id: 'Take Action', label: 'Take Action' },
  { id: 'Submit', label: 'Submit' },
  { id: 'Cancel', label: 'Cancel' },
  { id: 'Data', label: 'Data' },
  { id: 'Download', label: 'Download' },
  { id: 'View History', label: 'View History' },
  { id: 'Add Approver', label: 'Add' },
  { id: 'Edit', label: 'Edit' },
  { id: 'Delete', label: 'Delete' },
  { id: 'Approve Safety Stock', label: 'Approve Safety Stock' },
];

export const TEAMS_ALL: LabeledOption<TeamId>[] = [
  { id: 'AL Team', label: 'AL Team' },
];


export const MATRIX: any = {
  'Input View': {
    inbound:  { functions: ['Data' ], teams: ['AL Team'] },
    'Functionality': { functions: ['Take Action', 'Submit','Cancel','Download'], teams: ['AL Team'] },
    'AL Team': { functions: ['Take Action', 'Submit','Cancel','Download'], teams: ['AL Team'] },
    '': { functions: [], teams: [] },
  },
  'Output View': {
    inbound:  { functions: ['Data' ], teams: ['AL Team'] },
    'Functionality': { functions: ['View History','Download'], teams: ['AL Team'] },
    'AL Team': { functions: ['View History','Download'], teams: ['AL Team'] },
    '': { functions: [], teams: [] },
  },
  'SSA Dashboard': {
    inbound:  { functions: ['Data' ], teams: ['AL Team'] },
    outbound: { functions: ['Data'],  teams: ['AL Team'] },
    'Functionality': { functions: ['Download'], teams: ['AL Team'] },
    'AL Team': { functions: ['Download'], teams: ['AL Team'] },
    '': { functions: [], teams: [] },
  },
  'Approver Maintenance': {
    inbound:  { functions: ['Data' ], teams: ['AL Team'] },
    outbound: { functions: ['Data'],  teams: ['AL Team'] },
    'Functionality': { functions: ['Add Approver', 'Edit', 'Download'], teams: ['AL Team'] },
    'AL Team': { functions: ['Add Approver', 'Edit', 'Download'], teams: ['AL Team'] },
    '': { functions: [], teams: [] },
  },
  'Data Error': {
    inbound:  { functions: ['Data' ], teams: ['AL Team'] },
    outbound: { functions: ['Data'],  teams: ['AL Team'] },
    'Functionality': { functions: ['Download'], teams: ['AL Team'] },
    'AL Team': { functions: ['Download'], teams: ['AL Team'] },
    '': { functions: [], teams: [] },
  },
  'SSA Control': {
    inbound:  { functions: ['Data' ], teams: ['AL Team'] },
    outbound: { functions: ['Data'],  teams: ['AL Team'] },
    'Functionality': { functions: ['Edit', 'Delete', 'Download', 'Add Approver'], teams: ['AL Team'] },
    'AL Team': { functions: ['Edit', 'Delete', 'Download', 'Add Approver'], teams: ['AL Team'] },
    '': { functions: [], teams: [] },
  },
  Approver: {
    inbound:  { functions: ['Data' ], teams: ['AL Team'] },
    'Functionality': { functions: ['Download','Approve Safety Stock','Take Action'], teams: ['AL Team'] },
    'AL Team': { functions: ['Download','Approve Safety Stock','Take Action'], teams: ['AL Team'] },
    '': { functions: [], teams: [] },
  },
  '': {
    inbound: { functions: [], teams: [] },
    outbound: { functions: [], teams: [] },
    'Functionality': { functions: [], teams: [] },
    'AL Team': { functions: [], teams: [] },
    '': { functions: [], teams: [] },
  },
};

// Utility
export const mapByIds = <T extends { id: string }>(all: T[], ids: string[]) =>
  ids.map(id => all.find(x => x.id === id)).filter(Boolean) as T[];